module.exports = __webpack_public_path__ + "img/tiers.fbd9c833.png";